import React from 'react';

const ContainerWrapper = ({ children }) => <div className="BaseContainer">{children}</div>;

export default ContainerWrapper;
